import styled from 'styled-components'

export const Directorbackground = styled.div`
background-image: url('/website data for 2025-26/11_computer LAb/comp1.jpeg');
height:80vh;
background-repeat:no-repeat;
background-size:cover;
background-position:center;
display:flex;
flex-direction:column;
`
export const Sub = styled.div`
padding: 60px;
`